import {action, computed, makeObservable, observable, toJS} from 'mobx'

import {ContactService as Service} from 'rest/services/ContactService'
import {Stores} from './index'
import {ContactDetailDto} from 'rest/models/ContactDetailDto'
import {ContactEditDto} from 'rest/models/ContactEditDto'
import {ContactAddDto} from 'rest/models/ContactAddDto'

export class ContactStore {
  stores: Stores
  _contact: ContactDetailDto

  constructor(stores: Stores) {
    this.stores = stores
    makeObservable(this, {
      _contact: observable,
      contact: computed,
      getContact: action,
      addContact: action,
      editContact: action,
    })
  }

  get contact() {
    // if (localStorage.getItem('contact') !== 'undefined') {
    //   this._contact = JSON.parse(localStorage.getItem('contact'))
    // }
    return toJS(this._contact)
  }

  getContact = async (): Promise<any> => {
    if (this.stores.MerchantStore.merchant?.merchantId)
      try {
        const res = await Service.getApiContactGetList(
          this.stores.MerchantStore.merchant.merchantId
        )
        if (res.data) {
          this._contact = res.data[0]
          // localStorage.setItem('contact', JSON.stringify(this._contact))
          return this._contact
        }
        return null
      } catch (err) {
        this.stores.ErrorStore.handle(err)
      }
  }

  addContact = async (payload: ContactAddDto) => {
    try {
      const res = await Service.postApiContactAdd(payload)
      if (res.data) {
        this._contact = res.data
        // localStorage.setItem('contact', JSON.stringify(this._contact))
      }
    } catch (err) {
      this.stores.ErrorStore.handle(err)
    }
  }

  editContact = async (payload: ContactEditDto) => {
    try {
      const res = await Service.putApiContactEdit(payload)
      if (res.data) {
        this._contact = res.data
        // localStorage.setItem('contact', JSON.stringify(this._contact))
      }
      return res
    } catch (err) {
      this.stores.ErrorStore.handle(err)
    }
  }
}
